/// <reference path="../../app.definition.ts" />

import * as angular from "angular";
import * as _ from "lodash";
import { CacheService } from "@common/service/cache.service";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { TeamRole } from "@common/model/teamrole";

export interface ITeamRoleService {
    orgTeamRoles: any;
    getTeamRoles(subjectOrgId?: number, subjectTypeId?: string);
    getTeamRoleNames(subjectOrgId: number, subjectTypeId?: string);
    getTeamRoleById(teamRoleId: number, orgId: number);
}

export class TeamRoleService implements ITeamRoleService {
    orgTeamRoles = {};
    static $inject = ["$q", "CacheService", "ApiAdapterService"];

    constructor(private $q: ng.IQService,
        private $_cache: CacheService,
        private $_api: JavaApiAdapterService) {
    }

    // gets the team role
    getTeamRoles(subjectOrgId?: number, subjectTypeId?: string) {
        var deferred = this.$q.defer();
        this.$_api.getTeamRoles(subjectOrgId).then(
            (data) => {
                var roles = data.map((d) => new TeamRole().deserialize(d))
                    .filter(function (role) {
                        return !!role.roleName && role.roleName.length > 0;
                    });
                //Saving the teamroles in variable to help fetch the rolename
                const orgId = subjectOrgId || this.$_cache.getUser().organizationId;
                this.orgTeamRoles[orgId] = roles;

                var subjectTypeSpecificRoles = roles.filter(function (role) {
                    return !subjectTypeId || !role.subjectTypeId || (role.subjectTypeId == subjectTypeId || role.subjectTypeId == "BOTH");
                });
                deferred.resolve(subjectTypeSpecificRoles);
            }, (e) => {
                deferred.reject(e)
            });

        return deferred.promise;

    }

    getTeamRoleNames(subjectOrgId: number, subjectTypeId?: string): angular.IPromise<string[]> {
        return this.getTeamRoles(subjectOrgId, subjectTypeId).then((roles: TeamRole[]) => {
            const roleNames = _.map(roles, (role) => role.roleName);
            roleNames.push('Other');
            return roleNames;
        });
    }

    getTeamRoleById(teamRoleId: number, orgId: number) {
        if (!!this.orgTeamRoles[orgId] && this.orgTeamRoles[orgId].length > 0) {
            return this.orgTeamRoles[orgId].find((tr) => tr.id == teamRoleId);
        } else {
            this.getTeamRoles(orgId).then((s: TeamRole[]) => {
                return s.find((tr) => parseInt(tr.id, 10) === teamRoleId);
            }, (e) => {
                console.log(e);
                return null;
            });
        }
    }


}

angular.module('eCareVault.common.services')
    .service('TeamRoleService', TeamRoleService);
